<template>
    <el-container style="height: calc(100vh - 80px)" class="bg-white">
        <el-header style="padding: 0px; height: auto; ">
            <!-- title部 -->
            <div class="h-12 p-4 shadow-md">環境設定</div>
        </el-header>

        <!-- 主显示部 -->
        <el-main style="padding-block: 0px; margin-top: 20px;" v-loading="loading">
            <div class="border-b border-b-gray-300 pb-5">
                <span>APK Version管理</span>
                <div class="flex flex-col items-center">
                    <el-form :model="apkForm" :rules="apkRules" ref="apkFormRef" label-width="150px" style="width: 800px;">
                        <el-form-item label="Version番号" prop="version">
                            <el-input v-model="apkForm.version" placeholder="Version番号を入力"/>
                        </el-form-item>

                        <el-form-item label="URL" prop="url">
                            <el-input v-model="apkForm.url" placeholder="URLを入力"/>
                        </el-form-item>

                        <el-form-item label="INFO" prop="info">
                            <el-input v-model="apkForm.info" placeholder="INFOを入力" type="textarea" :rows="10"/>
                        </el-form-item>

                        <div class="flex justify-center">
                            <el-button type="primary" class="w-80" @click="handleChangeApk(apkFormRef)">保存</el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </el-main>

        <el-footer style="height: 20px;"> </el-footer>
    </el-container>
</template>

<script lang="ts">
import { getErrorMessage } from '@/components/common/errorMessage';
import { ErrorCode, ResponseData, ResponseStatus } from '@/components/common/response';
import { ApkInfo } from '@/components/models/apkInfo';
import axios, { AxiosResponse } from 'axios';
import { ElMessage, FormInstance, FormRules } from 'element-plus';
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
    name: 'MntEnv',
    setup() {
        const loading = ref<boolean>(true);
        const apkFormRef = ref<FormInstance>()

        const apkForm = ref<ApkInfo>({
            version: '',
            url: '',
            info: '',
        });

        const apkRules = ref<FormRules>({
            version: [
                { required: true, message: 'Version番号を入力してください', trigger: 'blur' },
                { pattern: /^\d+\.\d+\.\d+$/, message: '正しいVersion番号の形式で入力してください (例: 1.0.0)', trigger: 'blur' }
            ],
            url: [
                { required: true, message: 'URLを入力してください', trigger: 'blur' }
            ],
            info: [
                { required: true, message: 'INFOを入力してください', trigger: 'blur' },
            ],
        })

        onMounted(() => {
            getApk();
        });

        const handleChangeApk = async (formEl: FormInstance | undefined) => {
            if (!formEl) return
            await formEl.validate((valid) => {
                if (valid) {
                    updateApk(apkForm.value);
                }
            })
        }

        const updateApk = async (row: ApkInfo) => {
            try {
                loading.value = true;
                const res: AxiosResponse<ResponseData<ApkInfo>> = await axios.put(`/api/setting/apk`, row);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    ElMessage.success(res.data.message);
                } else {
                    ElMessage.error(res.data.message);
                }
                getApk();
            } catch (error) {
                ElMessage.error(getErrorMessage(error as Error));
            } finally {
                // 无论成功还是失败，最后都要关闭loading
                loading.value = false;
            }
        }

        const getApk = async () => {
            try {
                loading.value = true;
                const res: AxiosResponse<ResponseData<ApkInfo>> = await axios.get(`/api/setting/apk`);
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { data } = res.data;

                    apkForm.value = {
                        version: data!.version,
                        url: data!.url,
                        info: data!.info,
                    };
                } else {
                    ElMessage.error(res.data.message);
                }

            } catch (error) {
                ElMessage.error(getErrorMessage(error as Error));
            } finally {
                // 无论成功还是失败，最后都要关闭loading
                loading.value = false;
            }
        };

        return {
            loading,
            apkFormRef,
            apkForm,
            apkRules,
            handleChangeApk,
        }

    }
});
</script>